var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.25 6.00001L4.75018 9L9.75 3","stroke":"#07794F","strokeWidth":"1.3","strokeLinecap":"square"}));
}

Check.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = Check;

Check.default = Check;
